import { loadLudaAppEnv } from "./luda";

/**
 * @param {Record<string,string>} assets
 * @param {import("./common").Config} config
 */
export function loadBetaAppEnv(assets, config) {
	loadLudaAppEnv(assets, config);
	overwriteConfig(config);
	import(`../css/luda/style.css`);
}

/**
 * @param {import("./common").Config} config
 */
function overwriteConfig(config) {
	config.apiBaseUrl = "https://test.api.luda.farm";
	config.apiHost = "test.api.luda.farm";
	config.appId = "test.my.luda.farm";
	config.baseUrl = "https://test.my.luda.farm";
	config.brand = "luda";
	config.sp2gwHost = "test.sp2gw.luda.farm";
	config.sp2gwSelfSignedHost = "test.smartplug2.luda.farm";
	config.stripeBaseUrl = "https://dashboard.stripe.com/test";
	config.supportedDevices = [
		"farmcam-sim",
		"fencealarm2",
		"fencealarm",
		"smartplug2",
		"smartplug",
	];
}
